import { Injectable } from '@angular/core';

import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { FavouritesDashboardUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';

import { FavouritedItems, FavouritesSectionModel } from './favourites-dashboard.model';

export interface FavouritesFixturesRequest {
    fixtureFilters: StringDictionary<FavouritedItems[]>;
    fixturesCount: number;
}

@Injectable({ providedIn: 'root' })
export class FavouritesDashboardRequestBuilderService {
    buildRequest(currentRoute: string, favouritesSectionModel: FavouritesSectionModel[], sportId?: string): FavouritesFixturesRequest {
        let fixtureFilters: StringDictionary<FavouritedItems[]> = {};
        let totalCount = 0;
        if (currentRoute && favouritesSectionModel.length) {
            const selectedGeneralPill = favouritesSectionModel.find((favourite) => !!favourite.active);

            if (currentRoute === FavouritesDashboardUrlParam.Upcoming || currentRoute === FavouritesDashboardUrlParam.Events) {
                totalCount += (selectedGeneralPill && selectedGeneralPill.count) || 0;
                fixtureFilters = totalCount ? selectedGeneralPill!.additionalFilters || {} : {};
            }
            if (
                (currentRoute === FavouritesDashboardUrlParam.Competitions || currentRoute === FavouritesDashboardUrlParam.Players) &&
                selectedGeneralPill &&
                !!sportId
            ) {
                totalCount += selectedGeneralPill && selectedGeneralPill.count ? selectedGeneralPill.count : 0;

                if (selectedGeneralPill.id === '-1' && selectedGeneralPill.allItemIds && selectedGeneralPill.allItemIds.length && sportId) {
                    fixtureFilters[sportId] = selectedGeneralPill.allItemIds;
                } else if (selectedGeneralPill.type) {
                    fixtureFilters[sportId] = [
                        {
                            itemIds: [selectedGeneralPill.id],
                            type: selectedGeneralPill.type,
                        },
                    ];
                }
            }

            if (currentRoute === FavouritesDashboardUrlParam.Competitions || (currentRoute === FavouritesDashboardUrlParam.Players && !sportId)) {
                favouritesSectionModel.forEach((section) => {
                    totalCount += this.setFilterFromGridHeaderPills(section, fixtureFilters);
                });
            }
        }

        return { fixtureFilters, fixturesCount: totalCount };
    }

    private setFilterFromGridHeaderPills(section: FavouritesSectionModel, fixtureFilters: StringDictionary<FavouritedItems[]>): number {
        let selectedPillCount = 0;
        fixtureFilters[section.id] = [];
        if (section.gridHeaderPills) {
            const selectedGridHeaderPill = section.gridHeaderPills.find((pill) => !!pill.active);
            if (selectedGridHeaderPill && selectedGridHeaderPill.count) {
                selectedPillCount += selectedGridHeaderPill.count;
                fixtureFilters[section.id].push(
                    ...(selectedGridHeaderPill.allItemIds || [{ itemIds: [selectedGridHeaderPill.id], type: selectedGridHeaderPill.type! }]),
                );
            }
        }

        return selectedPillCount;
    }
}
